<template>
  <div>
    <Message type="info"> キャンペーンを開始するには、以下の3つを設定する必要があります。 </Message>

    <div class="intro-list">
      <div class="intro-item">
        <Panel>
          <div class="intro-label">1.キャンペーンの基本設定</div>
          タイトル、実施アカウント、開催期間といった基本的な情報を設定します。
        </Panel>
      </div>

      <div class="intro-item">
        <Panel>
          <div class="intro-label">2.応募条件の設定</div>
          キャンペーンの種類や応募投稿を判別するキーワードなど、どのような投稿を応募とみなすかを設定します。
        </Panel>
      </div>

      <div class="intro-item">
        <Panel>
          <div class="intro-label">3.応募グループの設定</div>
          応募は応募グループに蓄積されていきます。
          <br />
          応募グループごとに当選者の抽選や当選メッセージ(DM・メンション)の配信をします。
          <br />
          デフォルトで1つグループが作成されますが、追加作成すると応募の振り分けができます。
        </Panel>
      </div>
    </div>

    <div class="intro-checkbox">
      <el-checkbox v-model="is_check">以降、このメッセージを表示しない</el-checkbox>
    </div>

    <div class="intro-button">
      <el-button type="primary" @click="onClose">OK</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Message from '@/client/components/_atoms/Message.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import api from '@/client/core/api'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  components: {
    Message,
    Panel
  },
  computed: {
    ...mapState(useSystemStore, ['user'])
  },
  data() {
    return {
      is_check: true
    }
  },
  methods: {
    ...mapActions(useSystemStore, ['setUser']),
    async onClose() {
      if (this.is_check) {
        const result = await api.put('/me/settings', {
          settings: { isShowCampaignCreateIntro: Number(!this.is_check) }
        })

        if (result.data && this.user) {
          this.setUser({
            ...this.user,
            isFirstDisplay: result.data.isShowCampaignCreateIntro
          })
        }
      }

      this.$emit('close')
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.intro-list {
  margin-top: $spacing-unit * 2;
}

.intro-item:not(:first-child) {
  margin-top: $spacing-unit;
}

.intro-label {
  margin-bottom: $spacing-unit;
  font-weight: bold;
}

.intro-checkbox {
  margin-top: $spacing-unit * 2;

  :deep(.el-checkbox) {
    box-shadow: unset;
  }
}

.intro-button {
  margin-top: $spacing-unit * 3;
  text-align: right;
}
</style>
